import { TriggerType } from '@katanaperps/katana-perps-sdk';
import React, { useState } from 'react';

import { useInterval } from 'components/hooks';
import { getBestPriceFromDisplayedOrderbook } from 'components/orders/orderBook/orderBookService';
import { isTriggerTakeProfit } from 'components/orders/orderUtil';

import { TwoColumnData } from './layout';

export function DevTrigger({
  triggerPrice,
  triggerType,
  indexPrice,
}: {
  triggerPrice: number;
  triggerType: Extract<TriggerType, 'last' | 'index'>;
  indexPrice: string | undefined;
}) {
  const [state, setState] = useState<
    { buy: boolean; sell: boolean } | undefined
  >();
  const updateTimeSec = 3;
  useInterval(() => {
    const bestBid = getBestPriceFromDisplayedOrderbook('bid');
    const bestAsk = getBestPriceFromDisplayedOrderbook('ask');
    try {
      const buyTriggerTakeProfit = isTriggerTakeProfit({
        side: 'buy',
        triggerType,
        triggerPrice,
        indexPrice,
        bestAsk,
        bestBid,
      });
      const sellTriggerTakeProfit = isTriggerTakeProfit({
        side: 'sell',
        triggerType,
        triggerPrice,
        indexPrice,
        bestAsk,
        bestBid,
      });
      setState({ buy: buyTriggerTakeProfit, sell: sellTriggerTakeProfit });
    } catch (error) {
      console.debug(error);
      setState(undefined);
    }
  }, updateTimeSec * 1000);
  return (
    <>
      <TwoColumnData
        label="Trigger Type"
        buySide={!state ? '-' : state.buy ? 'TAKE PROFIT' : 'STOP LOSS'}
        sellSide={!state ? '-' : state.sell ? 'TAKE PROFIT' : 'STOP LOSS'}
      />
      <small>Updated once per {updateTimeSec} secs</small>
      <br />
      <br />
    </>
  );
}
